export const NAVIGATE = "prevenx/navigation/NAVIGATE"
export const CLEAR_NAVIGATION = "prevenx/navigation/CLEAR_NAVIGATION"